import {
  VantifyProxyResponse,
  vantifyRequest,
} from 'integrations-vantify-api-client';
import { VantifyAuth, VantifyQuery } from '../common';
import { SiteTenant, SiteTenantListResponse } from './types';

/**
 * Get all site tenants by automatically handling pagination
 * Fetches all site tenants data by making multiple API calls if needed
 */
export async function getAllSiteTenants(
  auth: VantifyAuth,
  userId: number,
  siteId: number,
  query?: VantifyQuery
): Promise<VantifyProxyResponse<SiteTenantListResponse>> {
  const DEFAULT_LIMIT = 500;
  const allSiteTenants: SiteTenant[] = [];
  let currentPage = 1;
  let totalPages;
  let totalCount = 0;

  do {
    const response = await vantifyRequest<SiteTenantListResponse>({
      method: 'GET',
      pathname: `users/${userId}/sitecontacts`,
      query: {
        ...query,
        type: 'tenant',
        site: siteId,
        page: currentPage,
        limit: DEFAULT_LIMIT,
      },
      auth,
    });

    if (response.status !== 200) {
      return response;
    }

    const data = response.data;

    allSiteTenants.push(...data.contacts);
    totalPages = data.pages;
    totalCount = data.count;

    currentPage++;
  } while (currentPage <= totalPages);

  return {
    status: 200,
    statusText: 'OK',
    data: {
      contacts: allSiteTenants,
      count: totalCount,
      pages: totalPages,
      limit: DEFAULT_LIMIT,
    },
  };
}
